(function () {
  function updateFbtCarousel(container) {
    if (!container) return;
    const carousel = container.querySelector('.ec-frequently-bought-together__products');
    const inner = container.querySelector('.ec-frequently-bought-together__products-inner');
    const dots = container.querySelectorAll('.ec-frequently-bought-together__dot');
    const prevButton = container.querySelector('.ec-frequently-bought-together__arrow--prev');
    const nextButton = container.querySelector('.ec-frequently-bought-together__arrow--next');
    if (!carousel || !inner) return;

    const products = inner.querySelectorAll('.ec-frequently-bought-together__product');
    const totalPages = products.length;
    let currentPage = parseInt(container.dataset.currentPage || '0', 10);
    currentPage = Math.max(0, Math.min(currentPage, totalPages - 1));
    container.dataset.currentPage = currentPage;

    const viewportWidth = carousel.offsetWidth;
    if (viewportWidth > 0) {
      const translateX = totalPages <= 1 ? 0 : currentPage * viewportWidth;
      inner.style.transform = 'translateX(-' + translateX + 'px)';
    }

    dots.forEach(function (dot, index) {
      if (index === currentPage) dot.classList.add('ec-frequently-bought-together__dot--active');
      else dot.classList.remove('ec-frequently-bought-together__dot--active');
    });

    if (prevButton) {
      prevButton.disabled = currentPage === 0;
      prevButton.style.opacity = currentPage === 0 ? '0.5' : '1';
    }
    if (nextButton) {
      nextButton.disabled = currentPage >= totalPages - 1;
      nextButton.style.opacity = currentPage >= totalPages - 1 ? '0.5' : '1';
    }
  }

  function initFbtCarousel(container) {
    if (!container || container.__ecFbtInitialized) return;
    container.__ecFbtInitialized = true;

    // Carousel buttons
    const prevBtn = container.querySelector('.ec-frequently-bought-together__arrow--prev');
    const nextBtn = container.querySelector('.ec-frequently-bought-together__arrow--next');
    const dots = container.querySelectorAll('.ec-frequently-bought-together__dot');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        let page = parseInt(container.dataset.currentPage || '0', 10);
        if (page > 0) {
          container.dataset.currentPage = page - 1;
          updateFbtCarousel(container);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const inner = container.querySelector('.ec-frequently-bought-together__products-inner');
        const total = inner ? inner.querySelectorAll('.ec-frequently-bought-together__product').length : 0;
        let page = parseInt(container.dataset.currentPage || '0', 10);
        if (page < total - 1) {
          container.dataset.currentPage = page + 1;
          updateFbtCarousel(container);
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        const page = parseInt(dot.dataset.page || '1', 10) - 1;
        container.dataset.currentPage = page;
        updateFbtCarousel(container);
      });
    });

    // Form submissions
    container.querySelectorAll('.ec-frequently-bought-together__add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var cartAddUrl = '/cart/add.js';
        if (typeof routes !== 'undefined' && routes.cart_add_url) {
          cartAddUrl = routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : routes.cart_add_url + '.js';
        } else if (form.dataset.cartAddUrl) {
          var base = form.dataset.cartAddUrl;
          cartAddUrl = base.endsWith('.js') ? base : base + '.js';
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData(form);
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          var sections = cartDrawer.getSectionsToRender().map(function (s) {
            return s.id;
          });
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        fetch(cartAddUrl, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (res) {
            if (!res.ok) return res.text().then(function (t) { throw new Error(t || res.status); });
            return res.json();
          })
          .then(function (response) {
            if (response.status) {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-busy');
              }
              return;
            }
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
              else cartDrawer.setAttribute('active', '');
            }
            var cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
              var updatePromise = cartDrawerItems.onCartUpdate();
              if (updatePromise && typeof updatePromise.then === 'function') {
                updatePromise.then(function () {
                  const fbt = document.querySelector('.ec-frequently-bought-together');
                  if (fbt) updateFbtCarousel(fbt);
                }).catch(function () {});
              }
            }
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fbt', cartData: response });
            }
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          });
      });
    });

    updateFbtCarousel(container);
  }

  function initAllFbt() {
    document.querySelectorAll('.ec-frequently-bought-together').forEach(initFbtCarousel);
  }

  if (!window.__EC_FBT_OBSERVED) {
    window.__EC_FBT_OBSERVED = true;
    const observer = new MutationObserver(function () {
      initAllFbt();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFbt);
  } else {
    initAllFbt();
  }
})();
